import axios from 'axios';
import urls from '../config/urls';

axios.defaults.withCredentials = true;
axios.defaults.timeout = 10000;

export async function getWatchlist() {
  return await axios.get(`${urls.adminHubUrl}/ui/api/zoomboard/watchlistmanager`);
}

export async function createWatchlistMember(memberData) {
  return await axios.post(`${urls.adminHubUrl}/ui/api/zoomboard/watchlistmanager`, memberData);
}

export async function updateWatchlistMember(memberId, data) {
  return await axios.put(`${urls.adminHubUrl}/ui/api/zoomboard/watchlistmanager/${memberId}`, data);
}

export async function deleteWatchlistMember(memberId) {
  return await axios.delete(`${urls.adminHubUrl}/ui/api/zoomboard/watchlistmanager/${memberId}`);
}

export async function connectWatchlistWebSocket(webinarId) {
  return await axios.post(`${urls.adminHubUrl}/ui/api/zoomboard/liveboard/connect`, { webinarId });
}

export async function disconnectWatchlistWebSocket() {
  return await axios.post(`${urls.adminHubUrl}/ui/api/zoomboard/liveboard/disconnect`);
}

export async function getWatchlistWebSocketStatus() {
  return await axios.get(`${urls.adminHubUrl}/ui/api/zoomboard/liveboard/status`);
}

export async function getLiveParticipants() {
  return await axios.get(`${urls.adminHubUrl}/ui/api/zoomboard/liveboard/participants`);
}

export async function updateParticipantAddressed(memberId, addressed) {
  return await axios.patch(`${urls.adminHubUrl}/ui/api/zoomboard/liveboard/participants/addressed`, { memberId, addressed });
}

export async function syncZoomParticipants(webinarId) {
  return await axios.get(`${urls.adminHubUrl}/ui/api/zoomboard/liveboard/live/${webinarId}`)
}

export async function resetAddressedParticipants() {
  return await axios.post(`${urls.adminHubUrl}/ui/api/zoomboard/liveboard/participants/addressed/reset`);
}